import * as React from "react";
import {
    SpsSummaryListRow,
    SpsSummaryListColumn,
    SpsSummaryListExpansion,
    SpsKeyValueList,
    SpsKeyValueListItem,
    SpsCard,
    SpsDropdown
} from "../index";

export class SpsSummaryListBasic extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static reactLive = {
        code: `
        <React.Fragment>
        <SpsSummaryListRow>
            <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
            </SpsSummaryListColumn>
            <SpsSummaryListColumn>
                <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                <div className="d-inline-block align-middle">
                    <div className="fs-18">
                        <a href="#">Heading</a>
                    </div>
                    <div className="fs-14">Sub Heading</div>
                </div>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 210.08 }}>
                <SpsKeyValueList inline>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Long Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 140 }}>
                <SpsKeyValueList>
                    <SpsKeyValueListItem itemKey="Buying From">
                        75 Companies
                        <div className="font-weight-light">38 of 75 Operational</div>
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 58 }} leaner>
                <SpsDropdown
                    label=""
                    icon="ellipses"
                    options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                />
            </SpsSummaryListColumn>
        </SpsSummaryListRow>
        <SpsSummaryListRow>
            <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
            </SpsSummaryListColumn>
            <SpsSummaryListColumn>
                <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                <div className="d-inline-block align-middle">
                    <div className="fs-18">
                        <a href="#">Heading</a>
                    </div>
                    <div className="fs-14">Sub Heading</div>
                </div>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 210.08 }}>
                <SpsKeyValueList inline>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Long Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 140 }}>
                <SpsKeyValueList>
                    <SpsKeyValueListItem itemKey="Buying From">
                        75 Companies
                        <div className="font-weight-light">38 of 75 Operational</div>
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 58 }} leaner>
                <SpsDropdown
                    label=""
                    icon="ellipses"
                    options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                />
            </SpsSummaryListColumn>
        </SpsSummaryListRow>
    </React.Fragment>
        `
    }
    // A testable, executable representation of this example.
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <React.Fragment>
                <SpsSummaryListRow data-testid={testId}>
                    <SpsSummaryListColumn style={{ width: 45.92 }} lean data-testid={testId}>
                        <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                        <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn data-testid={testId}>
                        <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                        <div className="d-inline-block align-middle">
                            <div className="fs-18">
                                <a href="#">Heading</a>
                            </div>
                            <div className="fs-14">Sub Heading</div>
                        </div>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn data-testid={testId} style={{ width: 210.08 }}>
                        <SpsKeyValueList inline>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Long Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn data-testid={testId} style={{ width: 140 }}>
                        <SpsKeyValueList>
                            <SpsKeyValueListItem itemKey="Buying From">
                                75 Companies
                                <div className="font-weight-light">38 of 75 Operational</div>
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn data-testid={testId} style={{ width: 58 }} leaner>
                        <SpsDropdown
                            label=""
                            icon="ellipses"
                            options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                        />
                    </SpsSummaryListColumn>
                </SpsSummaryListRow>
                <SpsSummaryListRow>
                    <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                        <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                        <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn>
                        <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                        <div className="d-inline-block align-middle">
                            <div className="fs-18">
                                <a href="#">Heading</a>
                            </div>
                            <div className="fs-14">Sub Heading</div>
                        </div>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 210.08 }}>
                        <SpsKeyValueList inline>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Long Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 140 }}>
                        <SpsKeyValueList>
                            <SpsKeyValueListItem itemKey="Buying From">
                                75 Companies
                                <div className="font-weight-light">38 of 75 Operational</div>
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 58 }} leaner>
                        <SpsDropdown
                            label=""
                            icon="ellipses"
                            options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                        />
                    </SpsSummaryListColumn>
                </SpsSummaryListRow>
            </React.Fragment>
        );
    }
}

export class SpsSummaryListExpandable extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static reactLive = {
        code: `
        <React.Fragment>
        <SpsSummaryListRow>
            <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
            </SpsSummaryListColumn>
            <SpsSummaryListColumn>
                <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                <div className="d-inline-block align-middle">
                    <div className="fs-18">
                        <a href="#">Heading</a>
                    </div>
                    <div className="fs-14">Sub Heading</div>
                </div>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 210.08 }}>
                <SpsKeyValueList inline>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Long Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                    <SpsKeyValueListItem itemKey={"Title"}>
                        Sub copy goes here
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 140 }}>
                <SpsKeyValueList>
                    <SpsKeyValueListItem itemKey="Buying From">
                        75 Companies
                        <div className="font-weight-light">38 of 75 Operational</div>
                    </SpsKeyValueListItem>
                </SpsKeyValueList>
            </SpsSummaryListColumn>
            <SpsSummaryListColumn style={{ width: 58 }} leaner>
                <SpsDropdown
                    label=""
                    icon="ellipses"
                    options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                />
            </SpsSummaryListColumn>
            <SpsSummaryListExpansion>
                <SpsCard
                    headerContent={() => (
                        <span style={{ color: "red" }}>
                            <i className="fa fa-users" /> Custom Header
                </span>
                    )}>
                    <div>Hello here is some content with custom</div>
                </SpsCard>
                <div className="text-center mt-3">
                    <button type="button" className="sps-btn sps-btn--link">Show More</button>
                </div>
            </SpsSummaryListExpansion>
        </SpsSummaryListRow>
    </React.Fragment>
        `
    }
    // A testable, executable representation of this example.
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <React.Fragment>
                <SpsSummaryListRow data-testid={testId}>
                    <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                        <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                        <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn>
                        <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                        <div className="d-inline-block align-middle">
                            <div className="fs-18">
                                <a href="#">Heading</a>
                            </div>
                            <div className="fs-14">Sub Heading</div>
                        </div>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 210.08 }}>
                        <SpsKeyValueList inline>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Long Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 140 }}>
                        <SpsKeyValueList>
                            <SpsKeyValueListItem itemKey="Buying From">
                                75 Companies
                                <div className="font-weight-light">38 of 75 Operational</div>
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 58 }} leaner>
                        <SpsDropdown
                            label=""
                            icon="ellipses"
                            data-testid={`${testId}__dropdown`}
                            options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                        />
                    </SpsSummaryListColumn>
                    <SpsSummaryListExpansion data-testid={testId}>
                        <SpsCard
                            headerContent={() => (
                                <span style={{ color: "red" }}>
                                    <i className="fa fa-users" /> Custom Header
                                </span>
                            )}>
                            <div>Hello here is some content with custom</div>
                        </SpsCard>
                        <div className="text-center mt-3">
                            <button type="button" className="sps-btn sps-btn--link">Show More</button>
                        </div>
                    </SpsSummaryListExpansion>
                </SpsSummaryListRow>
            </React.Fragment>
        );
    }
}

export class SpsSummaryListBorderless extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static reactLive = {
        code: `
        <React.Fragment>
            <SpsSummaryListRow>
                <SpsSummaryListColumn>
                    <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                    <div className="d-inline-block align-middle">
                        <div className="fs-18">
                            <a href="#">Heading</a>
                        </div>
                        <div className="fs-14">Sub Heading</div>
                    </div>
                </SpsSummaryListColumn>
                <SpsSummaryListColumn style={{ width: 58 }} leaner borderless>
                    <SpsDropdown
                        label=""
                        icon="ellipses"
                        options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                    />
                    </SpsSummaryListColumn>
            </SpsSummaryListRow>
        </React.Fragment>
        `
    }
    // A testable, executable representation of this example.
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <React.Fragment>
                <SpsSummaryListRow data-testid={testId}>
                    <SpsSummaryListColumn>
                        <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                        <div className="d-inline-block align-middle">
                            <div className="fs-18">
                                <a href="#">Heading</a>
                            </div>
                            <div className="fs-14">Sub Heading</div>
                        </div>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 58 }} leaner borderless>
                        <SpsDropdown
                            label=""
                            icon="ellipses"
                            data-testid={`${testId}__dropdown`}
                            options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                        />
                    </SpsSummaryListColumn>
                </SpsSummaryListRow>
            </React.Fragment>
        );
    }
}

export class SpsSummaryListSelectable extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static reactLive = {
        code: `
        <React.Fragment>
            <SpsSummaryListRow selected={true}>
                <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                    <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                    <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
                </SpsSummaryListColumn>
                <SpsSummaryListColumn>
                    <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                    <div className="d-inline-block align-middle">
                        <div className="fs-18">
                            <a href="#">Heading</a>
                        </div>
                        <div className="fs-14">Sub Heading</div>
                    </div>
                </SpsSummaryListColumn>
                <SpsSummaryListColumn style={{ width: 210.08 }}>
                    <SpsKeyValueList inline>
                        <SpsKeyValueListItem itemKey={"Title"}>
                            Sub copy goes here
                        </SpsKeyValueListItem>
                        <SpsKeyValueListItem itemKey={"Long Title"}>
                            Sub copy goes here
                        </SpsKeyValueListItem>
                        <SpsKeyValueListItem itemKey={"Title"}>
                            Sub copy goes here
                        </SpsKeyValueListItem>
                    </SpsKeyValueList>
                </SpsSummaryListColumn>
                <SpsSummaryListColumn style={{ width: 140 }}>
                    <SpsKeyValueList>
                        <SpsKeyValueListItem itemKey="Buying From">
                            75 Companies
                            <div className="font-weight-light">38 of 75 Operational</div>
                        </SpsKeyValueListItem>
                    </SpsKeyValueList>
                </SpsSummaryListColumn>
                <SpsSummaryListColumn style={{ width: 58 }} leaner>
                    <SpsDropdown
                        label=""
                        icon="ellipses"
                        options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                    />
                </SpsSummaryListColumn>
            </SpsSummaryListRow>
        </React.Fragment>
        `
    }
    // A testable, executable representation of this example.
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <React.Fragment>
                <SpsSummaryListRow  data-testid={testId} selected={true}>
                    <SpsSummaryListColumn style={{ width: 45.92 }} lean>
                        <i className="sps-icon sps-icon--md sps-icon-star d-block mb-2 yellow300" />
                        <i className="sps-icon sps-icon--md sps-icon-flag d-block yellow300" />
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn>
                        <i className="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1" />
                        <div className="d-inline-block align-middle">
                            <div className="fs-18">
                                <a href="#">Heading</a>
                            </div>
                            <div className="fs-14">Sub Heading</div>
                        </div>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 210.08 }}>
                        <SpsKeyValueList inline>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Long Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                            <SpsKeyValueListItem itemKey={"Title"}>
                                Sub copy goes here
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 140 }}>
                        <SpsKeyValueList>
                            <SpsKeyValueListItem itemKey="Buying From">
                                75 Companies
              <div className="font-weight-light">38 of 75 Operational</div>
                            </SpsKeyValueListItem>
                        </SpsKeyValueList>
                    </SpsSummaryListColumn>
                    <SpsSummaryListColumn style={{ width: 58 }} leaner>
                        <SpsDropdown
                            label=""
                            icon="ellipses"
                            data-testid={`${testId}__dropdown`}
                            options={[[{ label: "Option A" }, () => console.log("Option A")], [{ label: "Option B" }, () => console.log("Option B")]]}
                        />
                    </SpsSummaryListColumn>
                </SpsSummaryListRow>
            </React.Fragment>
        );
    }
}
